module.exports = __webpack_public_path__ + "img/statistiche.147c7d0e.png";